import { takeLatest } from 'redux-saga/effects';
import { AUTH_SERVICE_LOGOUT_PAGE } from './constants';
import { CLEAR_TOKEN } from './constants';
import StorageService from '../../../Utils/storageService';
import { USER_TOKEN_STORAGE_KEY } from '../../../pageComponents/LoginProvider/constants';

function* clearTokenSaga(action) {
  StorageService.removeKey('persist:root');
  StorageService.removeKey(USER_TOKEN_STORAGE_KEY);
  window.location.assign(AUTH_SERVICE_LOGOUT_PAGE);
}

export default function* watcher() {
  yield takeLatest(CLEAR_TOKEN, clearTokenSaga);
}
